import {string} from 'prop-types';
import React, {useEffect, useState} from 'react';
import { BarChartComponent } from '../../../components/charts/BarChartComponent';
import { CardComponent } from '../../../util/CardComponent';
import { useAppSelector } from '../hooks';
import { drilldownClickHandler } from '../utils';
import { selectCommentCategories } from './commentCategoriesSlice'

interface ICommentObject {
  comment: string
  commentType: string
}

export function CommentCategoriesComponent() {
  const commentCategoriesState = useAppSelector(selectCommentCategories);
  const{chartSubtitle, chartData, chartCategories, isLoading} = commentCategoriesState;
  const [cardTitle, setCardTitle] = useState(
    'Categories'
  );

  useEffect(() => {
    setCardTitle(isLoading ? 'Categories' : '');
  }, [isLoading]);

  return(
    <div>
        <CardComponent
      title={cardTitle}
      isLoading={isLoading}
    >
      {(!isLoading) && (
        <BarChartComponent
          name={'cat'}
          title={'Categories'}
          categories={chartCategories}
          dataPoints={chartData}
          htmlSubtitle={chartSubtitle}
          chartHeight={chartCategories.length * 25 > 500 ? chartCategories.length * 25 : 500}
          click={(commentObject: ICommentObject) => {
            /**
             * Fixme
             * Before releasing this to production, make sure
             * callback function works as expected.
             */
            const {comment, commentType} = commentObject;
            // @ts-ignore
            window.filterComment(comment, commentType);
          }}
          tooltipFormatterFunction={function() {
            return this.x + '<br/>' + 'Top performer' + ': <span>' + this.point.y + '' + '</span><br/>';
          }}
        />
      )}

    </CardComponent>
    </div>
  )
}
